<template>
  <v-responsive class="overflow-y-auto" max-height="calc(80vh - 320px)">
    <v-data-table
      v-model="selectedStudent"
      :options.sync="studentTableOptions"
      :server-items-length="totalItems"
      :headers="headers"
      :items-per-page="5"
      :items="students"
      :footer-props="footerTable"
      item-key="id"
      loading-text="Đang Tải"
      show-select
      :loading="loading"
    >
      <template v-slot:[`item.name`]="{ item }">
        <card-student-name :student="item" link />
      </template>
      <template v-slot:[`item.dob`]="{ item }">
        <span>{{ item.dob | ddmmyyyy }}</span>
      </template>
      <template v-slot:[`item.currentClass`]="{ item }">
        <span v-if="item.currentClass">{{ item.currentClass.title }}</span>
      </template>
    </v-data-table>
  </v-responsive>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapState, mapActions, mapMutations } from 'vuex'

const headers = [
  { text: 'Tên học sinh', value: 'name', align: 'left', sortable: false },
  { text: 'Ngày sinh', value: 'dob', align: 'center', sortable: false },
  { text: 'Lớp', value: 'currentClass', align: 'center', sortable: false, width: '100' }
]

export default {
  components: { CardStudentName },
  data() {
    return {
      headers,
      studentTableOptions: {},
      selectedStudent: []
    }
  },
  computed: {
    ...mapState('students', ['totalItems', 'students', 'pageText', 'loading']),
    footerTable() {
      const footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) footer['items-per-page-options'] = [5, 10, 15]
      return footer
    }
  },
  async created() {
    await this.searchStudents({})
  },
  methods: {
    ...mapActions('students', ['requestPageSettings', 'searchStudents']),
    ...mapMutations('mealGroupStudent', ['setSelectedStudent']),
    clearSelected() {
      this.selectedStudent = []
    }
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({ page: newOptions.page, itemsPerPage: newOptions.itemsPerPage })
        }
      },
      deep: true
    },
    selectedStudent() {
      this.setSelectedStudent(this.selectedStudent)
    }
  }
}
</script>
